export const MASTER_BUSINESS_MESSAGE_CONSTANTS = {
  // Title
  TITLE_PUBLIC_HOLIDAY: 'TITLE.PUBLIC_HOLIDAY_TITLE',
  TITLE_BUSINESS_ROLE: 'TITLE.BUSINESS_ROLE_TITLE',

  TITLE_TRAINING_LICENSE: 'TITLE.TRAINING_LICENSE_TITLE',
  TITLE_STRESS_PROFILE: 'TITLE.STRESS_PROFILE_TITLE',
  TITLE_LEAVE: 'TITLE.LEAVE_TITLE',
  TITLE_PENDING_BUSINESS_USER: 'TITLE.PENDING_BUSINESS_USER_TITLE',


  // Success Add
  SUCCESS_PUBLIC_HOLIDAY_ADD: 'SUCCESS.PUBLIC_HOLIDAY_ADD',
  SUCCESS_TRAINING_LICENSE_ADD: 'SUCCESS.TRAINING_LICENSE_ADD',
  SUCCESS_STRESS_PROFILE_ADD: 'SUCCESS.STRESS_PROFILE_ADD',
  SUCCESS_LEAVE_ADD: 'SUCCESS.LEAVE_ADD',

  // Success Update
  SUCCESS_PUBLIC_HOLIDAY_UPDATE: 'SUCCESS.PUBLIC_HOLIDAY_UPDATE',
  SUCCESS_STRESS_PROFILE_UPDATE: 'SUCCESS.STRESS_PROFILE_UPDATE',
  SUCCESS_TRAINING_LICENSE_UPDATE: 'SUCCESS.TRAINING_LICENSE_UPDATE',
  SUCCESS_LEAVE_UPDATE: 'SUCCESS.LEAVE_UPDATE',

  // Success Approve
  SUCCESS_PENDING_BUSINESS_USER_APPROVE: 'SUCCESS.PENDING_BUSINESS_USER_APPROVE',

  // Success Reject
  SUCCESS_PENDING_BUSINESS_USER_REJECT: 'SUCCESS.PENDING_BUSINESS_USER_REJECT',

  // Sucess Delete
  SUCCESS_PUBLIC_HOLIDAY_DELETE: 'SUCCESS.PUBLIC_HOLIDAY_DELETE',
  SUCCESS_STRESS_PROFILE_DELETE: 'SUCCESS.STRESS_PROFILE_DELETE',
  SUCCESS_TRAINING_LICENSE_DELETE: 'SUCCESS.TRAINING_LICENSE_DELETE',
  SUCCESS_LEAVE_DELETE: 'SUCCESS.LEAVE_DELETE',
  SUCCESS_INSERT_BUSINESS_ROLE: 'SUCCESS.INSERT_BUSINESS_ROLE',
  SUCCESS_UPDATE_BUSINESS_ROLE: 'SUCCESS.UPDATE_BUSINESS_ROLE',
};
